export class FilterParameters {
    public query: string;

    public constructor(input: [string, string][]) {
        for (const tuple of input) {
            if (tuple?.length === 2) {
                const key: string = tuple[0];
                const value: string = tuple[1];
                if (value?.trim().length > 0) {
                    if (key === 'query') {
                        this.query = value.substring(0, 255);
                    }
                }
            }
        }
    }
}